import { tr } from './translate';

// Бэкенд сохраняет в базе часть текстов на узбекском (имена автосозданных контактов,
// записи ленты активности). Менять данные нельзя, поэтому на отображении распознаём
// известные шаблоны и показываем их на языке интерфейса. Незнакомый текст возвращается как есть.
const BULK = /\s—\sommaviy(?=$|:)/;

export function srv(text) {
  if (typeof text !== 'string' || !text) return text;

  let m = text.match(/^Noma'lum \((.+)\)$/);
  if (m) return tr('serverText.unknownPhone', { phone: m[1] });
  if (text === "Noma'lum") return tr('serverText.unknown');

  const bulk = BULK.test(text);
  const s = bulk ? text.replace(BULK, '') : text;
  let out = null;

  if ((m = s.match(/^(.+)ga biriktirildi$/))) out = tr('serverText.assignedTo', { name: m[1] });
  else if ((m = s.match(/^Arxivlandi(?:: (.+))?$/))) out = tr('serverText.archived') + (m[1] ? ': ' + m[1] : '');
  else if (s === 'Arxivdan qaytarildi') out = tr('serverText.unarchived');
  else if (s === 'Biriktirilishi bekor qilindi') out = tr('serverText.unassigned');
  else if (s === "O'ziga biriktirib oldi") out = tr('serverText.claimed');

  if (out === null) return bulk ? s + tr('serverText.bulk') : text;
  return bulk ? out + tr('serverText.bulk') : out;
}
